import distance from '@turf/distance';
import { lineString, Position } from '@turf/helpers';
import length from '@turf/length';

export class GpsHelper {
  static getMetersDistancePoint(point1: Position, point2: Position): number {
    return distance(point1, point2, { units: 'meters' });
  }

  static getMetersDistance(point1: google.maps.LatLng, point2: google.maps.LatLng): number {
    const turfPoint1 = [point1.lng(), point1.lat()];
    const turfPoint2 = [point2.lng(), point2.lat()];
    return this.getMetersDistancePoint(turfPoint1, turfPoint2);
  }

  static getMetersDistanceLiteral(point1: google.maps.LatLngLiteral, point2: google.maps.LatLngLiteral): number {
    const turfPoint1 = [point1.lng, point1.lat];
    const turfPoint2 = [point2.lng, point2.lat];
    return this.getMetersDistancePoint(turfPoint1, turfPoint2);
  }

  static getGeoJsonPoint(point: google.maps.LatLng | google.maps.LatLngLiteral): Position {
    if (point instanceof google.maps.LatLng) {
      return [point.lng(), point.lat()];
    } else {
      return [point.lng, point.lat];
    }
  }
  static getGeoJsonPointsLatLng(point: google.maps.LatLng[]) {
    return point.map((o) => this.getGeoJsonPoint(o));
  }
  static getGeoJsonPointsLatLngLiteral(point: google.maps.LatLngLiteral[]) {
    return point.map((o) => this.getGeoJsonPoint(o));
  }

  static findPathLengthInMeters(points: google.maps.LatLng[] | google.maps.LatLngLiteral[]): number {
    if (points[0] instanceof google.maps.LatLng) {
      const line = lineString([...this.getGeoJsonPointsLatLng(points as google.maps.LatLng[])]);
      return length(line, { units: 'meters' });
    } else {
      const line = lineString([...this.getGeoJsonPointsLatLngLiteral(points as google.maps.LatLngLiteral[])]);
      return length(line, { units: 'meters' });
    }
  }
}
